export const ANO_PERIODO_ANUAL = 2001;

/** Datas recebidas da API representam calendário, não instantes UTC. */
export const dataPeriodoLocal = (value: Date | string): Date => {
  if (typeof value === 'string') {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
    if (!match) return new Date(NaN);
    // Preserva 29/02 legado para que a validação solicite sua correção.
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12);
  }
  return value;
};

export const fevereiro29 = (value: Date): boolean => value.getMonth() === 1 && value.getDate() === 29;

export const dataPeriodoEdicao = (value: Date | string): Date => {
  const data = dataPeriodoLocal(value);
  return fevereiro29(data) ? data : new Date(ANO_PERIODO_ANUAL, data.getMonth(), data.getDate(), 12);
};

/** Serializa o dia/mês local sem permitir que o fuso altere o dia na API. */
export const dataPeriodoApi = (value: Date | null): Date | null => {
  if (value === null) return null;
  if (Number.isNaN(value.getTime()) || fevereiro29(value)) throw new Error('Informe um dia/mês válido. Fevereiro termina em 28/02.');
  return new Date(Date.UTC(ANO_PERIODO_ANUAL, value.getMonth(), value.getDate()));
};

export const formatarPeriodo = (value: Date | string): string => {
  const data = dataPeriodoLocal(value);
  return `${String(data.getDate()).padStart(2, '0')}/${String(data.getMonth() + 1).padStart(2, '0')}`;
};
